import React, { Fragment, useState, useEffect, useContext } from "react";
import CustomContext from "../../_helper/Customizer";
import { MenuTenant } from "./MenuTenant";
import { MenuAdmin } from "./MenuAdmin";
import { MenuSadmin } from "./MenuSadmin";
import { MenuCustom } from "./MenuCustom";
import SidebarIcon from "./SidebarIcon";
import SidebarLogo from "./SidebarLogo";
import SidebarMenu from "./SidebarMenu";

const Sidebar = (props) => {
  const customizer = useContext(CustomContext);
  const { toggleIcon } = useContext(CustomContext);
  const id = window.location.pathname.split("/").pop();
  const defaultLayout = Object.keys(customizer.layout);

  const layout = id ? id : defaultLayout;

  const userType = localStorage.getItem("usertype");

  const accessPermissions = {
    accessDashboard: localStorage.getItem("accessDashboard"),
    accessAnalytics: localStorage.getItem("accessAnalytics"),
    accessReports: localStorage.getItem("accessReports"),
    accessRevenueReports: localStorage.getItem("accessRevenueReports"),
    accessDataGrid: localStorage.getItem("accessDataGrid"),
    accessGeneralSettings: localStorage.getItem("accessGeneralSettings"),
    manageGeneralSettings: localStorage.getItem("manageGeneralSettings"),
    accessTenants: localStorage.getItem("accessTenants"),
    manageTenants: localStorage.getItem("manageTenants"),
    manageConfigurations: localStorage.getItem("manageConfigurations"),
    manageUsers: localStorage.getItem("manageUsers"),
    manageUserProfile: localStorage.getItem("manageUserProfile"),
    accessLogs: localStorage.getItem("accessLogs"),
    manageScheduleReports: localStorage.getItem("manageScheduleReports"),
    tenantPortalManage: localStorage.getItem("tenantPortalManage"),
    bulkDataUpload: localStorage.getItem("bulkDataUpload"),
    auditRequired: localStorage.getItem("auditRequired"),
    accessAudit: localStorage.getItem("accessAudit"),
    dataMode: localStorage.getItem("dataMode")
  };

  const itemwiseReports = [
    "Itemwise Detail Report",
    "Invoicewise Report",
    "Hourly Sales Report",
    "Tenant Itemwise Report",
    "TimeSeries Trend",
  ];

  // These have an invoicewise-mode equivalent sourced from the invoice model, so they're visible
  // for both itemwise and invoicewise (unlike the rest of itemwiseReports, which stay itemwise-only)
  const DUAL_MODE_REPORTS = ["Invoicewise Report", "Hourly Sales Report", "TimeSeries Trend"];

  const applySystemConfigFilters = (menuItems) => {
    return menuItems
      .filter((menu) => {
        if (menu.menutitle === "Audit" && accessPermissions.auditRequired !== "true") return false;
        return true;
      })
      .map((menu) => {
        if (menu.menutitle === "Reports") {
          menu.Items = menu.Items.map((section) => {
            if (section.children) {
              section.children = section.children.filter((child) => {
                if (child.title === "Audit Detail Report" && accessPermissions.auditRequired !== "true") return false;
                // These reports also apply to invoicewise mode, sourced from the invoice model there
                if (DUAL_MODE_REPORTS.includes(child.title)) {
                  return accessPermissions.dataMode === "itemwise" || accessPermissions.dataMode === "invoicewise";
                }
                if (itemwiseReports.includes(child.title) && accessPermissions.dataMode !== "itemwise") return false;
                return true;
              });
            }
            return section;
          });
        }
        if (menu.menutitle === "Data Grid") {
          const isBackendUser = localStorage.getItem("usertype") === "Backend User";
          menu.Items = menu.Items
            .filter((item) => {
              if (item.title === "Invoice Grid - Live") {
                return accessPermissions.dataMode === "invoicewise" && isBackendUser;
              }
              if (item.title === "Item Grid - Live") {
                return accessPermissions.dataMode === "itemwise" && isBackendUser;
              }
              if (item.title === "Data Grid - UAT") {
                return isBackendUser;
              }
              if (item.title === "Invoice Grid - UAT") {
                return accessPermissions.dataMode === "invoicewise" && isBackendUser;
              }
              if (item.title === "Item Grid - UAT") {
                return accessPermissions.dataMode === "itemwise" && isBackendUser;
              }
              return true;
            })
            .map((item) => {
              // The "Live" suffix only disambiguates from the UAT grids, which
              // only Backend Users can see - everyone else just gets the plain name.
              if (!isBackendUser && (item.title === "Data Grid - Live" || item.title === "Invoice Grid - Live" || item.title === "Item Grid - Live")) {
                return { ...item, title: item.title.replace(" - Live", "") };
              }
              return item;
            });
        }
        return menu;
      });
  };



  const filterMenuItems = (menuItems) => {
    return menuItems
      .filter((menu) => {
        // Top-level filtering based on permissions
        console.log(accessPermissions)
        if (menu.menutitle === "DashBoard" && accessPermissions.accessDashboard === "1") return true;
        if (menu.menutitle === "Analytics" && accessPermissions.accessAnalytics === "1") return true;
        if (menu.menutitle === "Reports" && (accessPermissions.accessReports === "1" || accessPermissions.accessRevenueReports === "1")) return true;
        if (menu.menutitle === "Data Grid" && accessPermissions.accessDataGrid === "1") return true;
        if (menu.menutitle === "") return true;
        // Audit also needs the concessionaire's audit_required, enforced in applySystemConfigFilters
        if (menu.menutitle === "Audit" && (localStorage.getItem("usertype") === "Backend User" || accessPermissions.accessAudit === "1")) return true;

        // General Settings filtering
        if (menu.menutitle === "General Settings") {

          // Show all items if access or manage general settings is enabled
          if (accessPermissions.accessGeneralSettings === "1" || accessPermissions.manageGeneralSettings === "1") {
            return true; // Show all items
          } else {
            // Check for tenants permission
            menu.Items = menu.Items.filter((item) => {
              if (item.title === "Tenants" && (accessPermissions.accessTenants === "1" || accessPermissions.manageTenants === "1")) {
                return true; // Show Tenants item if either tenant permission is granted
              }
              return false; // Otherwise, don't show
            });
            return menu.Items.length > 0; // Return true if "Tenants" is available
          }
        }

        // Configurations
        if (menu.menutitle === "Configurations" && accessPermissions.manageConfigurations === "1") return true;


        // Admin Settings
        if (menu.menutitle === "Admin Settings") {
          return (
            accessPermissions.manageUsers === "1" ||
            accessPermissions.manageUserProfile === "1" ||
            accessPermissions.accessLogs === "1" ||
            accessPermissions.manageScheduleReports === "1" ||
            accessPermissions.tenantPortalManage === "1" ||
            accessPermissions.bulkDataUpload === "1"
          );
        }

        return false; // Default case if no permissions match
      })
      .map((menu) => {
        // Further filtering for Admin Settings after initial filter
        if (menu.menutitle === "Admin Settings") {
          menu.Items = menu.Items.filter((item) => {
            if (item.title === "User Profiles" && accessPermissions.manageUserProfile === "1") return true;
            if (item.title === "Users" && accessPermissions.manageUsers === "1") return true;
            if (item.title === "Logs" && accessPermissions.accessLogs === "1") return true;
            if (item.title === "Schedule Reports" && accessPermissions.manageScheduleReports === "1") return true;
            if (item.title === "Tenant Portal" && accessPermissions.tenantPortalManage === "1") return true;
            if (item.title === "Live Health Checkup" && localStorage.getItem("usertype") === 'Backend User') return true;
            if (item.title === "Bulk Import" && (accessPermissions.bulkDataUpload === "1" || localStorage.getItem("usertype") === 'Backend User')) return true;
            if (item.title === "Bulk Import Log" && localStorage.getItem("usertype") === 'Backend User') return true;
            // if (item.title === "Bulk Import") return true;
            return false;
          });
        }

        if (menu.menutitle === "General Settings" && accessPermissions.accessGeneralSettings !== "1" && accessPermissions.manageGeneralSettings !== "1") {
          // Ensure only Tenants are shown if no general settings access
          menu.Items = menu.Items.filter((item) => {
            return item.title === "Tenants" && (accessPermissions.accessTenants === "1" || accessPermissions.manageTenants === "1");
          });
        }

        if (menu.menutitle === "Reports") {
          menu.Items = menu.Items.map((section) => {
            if (section.children) {
              section.children = section.children.filter((child) => {

                // ❌ Hide only Revenue Share Report
                if (
                  child.title === "Revenue Share Report" &&
                  accessPermissions.accessRevenueReports !== "1"
                ) {
                  return false;
                }

                // ✅ Keep everything else
                return true;
              });
            }
            return section;
          });
        }

        return menu;
      });
  };



  const [mainmenu, setMainMenu] = useState([]);

  // The filters above reassign menu.Items, so always work on a copy: MenuAdmin/MenuCustom are
  // module-level arrays shared across renders and logins, and mutating them would strip items
  // permanently for the rest of the page session.
  const cloneMenu = (menuItems) => JSON.parse(JSON.stringify(menuItems));

  useEffect(() => {
    let selectedMenu;
    switch (userType) {
      case "admin":
        selectedMenu = applySystemConfigFilters(cloneMenu(MenuAdmin));
        break;
      case "Backend User":
        selectedMenu = applySystemConfigFilters(filterMenuItems(cloneMenu(MenuAdmin)));
        break;
      case "sadmin":
        selectedMenu = cloneMenu(MenuSadmin);
        break;
      case "tenant":
        selectedMenu = cloneMenu(MenuTenant);
        break;
      default:
        selectedMenu = applySystemConfigFilters(filterMenuItems(cloneMenu(MenuCustom)));
    }
    console.log('Filtered Menu:', selectedMenu);
    setMainMenu(selectedMenu);
  }, [userType]);

  const [width, setWidth] = useState(0);

  const handleResize = () => {
    setWidth(window.innerWidth - 500);
  };

  const handleScroll = () => {
    if (window.scrollY > 400) {
      document.querySelector(".sidebar-main").className = "sidebar-main hovered";
    } else {
      if (document.getElementById("sidebar-main")) document.querySelector(".sidebar-main").className = "sidebar-main";
    }
  };

  useEffect(() => {
    document.querySelector(".left-arrow").classList.add("d-none");
    window.addEventListener("resize", handleResize);
    handleResize();
    const currentUrl = window.location.pathname;

    if (Array.isArray(mainmenu)) {
      mainmenu.map((items) => {
        items.Items.filter((Items) => {
          if (Items.path === currentUrl) setNavActive(Items);
          if (!Items.children) return false;
          Items.children.filter((subItems) => {
            if (subItems.path === currentUrl) setNavActive(subItems);
            if (!subItems.children) return false;
            subItems.children.filter((subSubItems) => {
              if (subSubItems.path === currentUrl) {
                setNavActive(subSubItems);
                return true;
              } else {
                return false;
              }
            });
            return subItems;
          });
          return Items;
        });
        return items;
      });
    }

    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, [layout, mainmenu]);

  const activeClass = () => {
    document.querySelector(".bg-overlay1").classList.add("active");
  };

  const setNavActive = (item) => {
    if (Array.isArray(mainmenu)) {
      mainmenu.map((menuItems) => {
        menuItems.Items.filter((Items) => {
          if (Items !== item) {
            Items.active = false;
            document.querySelector(".bg-overlay1").classList.remove("active");
          }
          if (Items.children && Items.children.includes(item)) {
            Items.active = true;
            document.querySelector(".sidebar-links").classList.add("active");
          }
          if (Items.children) {
            Items.children.filter((submenuItems) => {
              if (submenuItems.children && submenuItems.includes(item)) {
                Items.active = true;
                submenuItems.active = true;
                return true;
              } else {
                return false;
              }
            });
          }
          return Items;
        });
        return menuItems;
      });
    }
    item.active = !item.active;
    setMainMenu((prevMainMenu) => (Array.isArray(prevMainMenu) ? [...prevMainMenu] : []));
  };

  const closeOverlay = () => {
    document.querySelector(".bg-overlay1").classList.remove("active");
    document.querySelector(".sidebar-links").classList.remove("active");
  };

  return (
    <Fragment>
      <div
        className="bg-overlay1"
        onClick={() => {
          closeOverlay();
        }}></div>
      <div className={`sidebar-wrapper ${toggleIcon ? "close_icon" : ""}`} sidebar-layout="stroke-svg">
        <SidebarIcon />
        <SidebarLogo />
        <SidebarMenu setMainMenu={setMainMenu} props={props} setNavActive={setNavActive} activeClass={activeClass} width={width} />
      </div>
    </Fragment>
  );
};

export default Sidebar;





